
.pill {
    display: inline-flex;
    justify-content: center;
    align-items: center;
    min-height: 1.25rem;
    min-width: 1.25rem;
    padding: 0 0.5rem;
    
    border-radius: 1000px;
    border: 1px solid var(--static-divider-standard);
}